import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { VideoComponent } from './video-component.js';
import 'lodash';
import 'react-dom';
import 'wix-rich-content-ui-components';
import '../style-inject.es-e7b07dd7.js';
import '../dataHooks.js';
import '../video-viewer-cccd0280.js';
import 'wix-rich-content-common';
import '../IframePlayer.js';
import '../reactPlayerWrapper.js';
import 'wix-react-player';
import '../constants.js';
import 'ricos-schema';

const Video = ({
  settings,
  componentData,
  updateAttributes,
  node
}) => {
  const { t } = useContext(RicosContext);
  const { loading, loadingPercentage, id } = node.attrs;
  return /* @__PURE__ */ React.createElement(
    VideoComponent,
    {
      componentData,
      t,
      settings,
      updateAttributes,
      isLoading: loading,
      loadingPercentage,
      nodeId: id
    }
  );
};

export { Video };
//# sourceMappingURL=component.js.map
